import * as React from "react";
import "./Layout.css";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Sidebar from "../Sidebar/Index";
import { authClient, isOktaDisabled, devEmail } from "../../Utils/Common";
import { toast } from "react-toastify";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

import {
  APIUrlThree,
  APIUrlToken,
  GetOktaAuthData,
  GetUserId,
  SetOktaAuthData,
  SetUserId,
} from "../../Utils/Utils";
import axios from "axios";
import MFooter from "../MobileResponsive/MFootor/MFooter";
import MSidebar from "../MobileResponsive/MSidebar/MSidebar";
import { useNavigate } from "react-router-dom";
import { useOktaAuth } from "@okta/okta-react";
import MHeader from "../MobileResponsive/MHeader/MHeader";
import { CONTACT_US } from "../../Utils/Constants";
import { Button, Modal } from "@mui/material";
const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  height: "65px",
}));
export default function Layout({
  children,
  refState,
  setRefState,
  setRefStatenew,
  refStatenew,
}) {
  const loggedUser = GetOktaAuthData();
  const { oktaAuth } = useOktaAuth();
  const [remainingMinutes, setRemainingMinutes] = React.useState(0);
  const [timeWarning, setTimeWarning] = React.useState(false);

  // const style = {
  //   position: "absolute",
  //   top: "50%",
  //   left: "50%",
  //   transform: "translate(-50%, -50%)",
  //   width: 450,
  //   bgcolor: "background.paper",
  //   boxShadow: 24,
  //   borderRadius: "8px",
  // };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: { xs: "90%", sm: 400, md: 450 },
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: "12px",
    p: 3,
  };
  const warningShownRef = React.useRef(
    sessionStorage.getItem("sessionWarningShown") === "true",
  );
  let navigate = useNavigate();
  React.useEffect(() => {
    if (isOktaDisabled) {
      const storedAuth = GetOktaAuthData();
      if (!storedAuth || !storedAuth.user) {
        const email = devEmail || "developer@example.com";
        const fakeAuth = {
          user: {
            profile: {
              login: email,
              email: email,
              firstName: "Dev",
              lastName: "User",
            },
          },
          isAuthenticated: true,
        };
        SetOktaAuthData("auth", fakeAuth);
        localStorage.setItem("email", email);
        SetUserId("userId", 1);
      }
    }

    const checkTokenExpiry = async () => {
      if (isOktaDisabled) return;
      if (warningShownRef.current) return; // Already shown this session, skip

      const accessToken = await authClient.tokenManager.get("accessToken");
      if (accessToken) {
        const expiryTime = new Date(accessToken.expiresAt * 1000);
        console.log(expiryTime, "expiryTime");

        const expiresIn = expiryTime - Date.now();
        const minutesLeft = Math.floor(expiresIn / 60000);
        setRemainingMinutes(minutesLeft);

        const msUntilWarning = expiresIn - 25 * 60 * 1000;

        if (msUntilWarning > 0) {
          const warningTimer = setTimeout(() => {
            setRemainingMinutes(25);
            setTimeWarning(true);
            warningShownRef.current = true;
            sessionStorage.setItem("sessionWarningShown", "true"); // ✅ Add this
          }, msUntilWarning);

          return () => clearTimeout(warningTimer);
        } else if (minutesLeft > 0) {
          setTimeWarning(true);
          warningShownRef.current = true;
          sessionStorage.setItem("sessionWarningShown", "true"); // ✅ Add this
        }
      } else {
        console.warn("No access token found.");
      }
    };

    // const checkTokenExpiry = async () => {
    //   if (isOktaDisabled) return;
    //   const accessToken = await authClient.tokenManager.get("accessToken");
    //   if (accessToken) {
    //     const expiryTime = new Date(accessToken.expiresAt * 1000);

    //     const expiresIn = expiryTime - Date.now();
    //   } else {
    //     console.warn("No access token found.");
    //   }
    // };
    checkTokenExpiry();
    const handleTokenExpiry = async (key) => {
      if (isOktaDisabled) return;
      toast.error("Session Expired");
      console.warn(`${key} expired. Logging out user...`);
      await generateLastSessionReport();
      setTimeout(() => {
        authClient.signOut();
      }, 1000);
    };
    authClient.tokenManager.on("expired", handleTokenExpiry);
    return () => {
      authClient.tokenManager.off("expired", handleTokenExpiry);
    };
  }, []);
  const generateLastSessionReport = async () => {
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APIUrlToken(),
      },
      url: `${APIUrlThree()}/generate_last_session_report?user_email=${
        loggedUser?.user?.profile?.username
      }`,
    };
    axios(option)
      .then(() => {})
      .catch((err) => {
      });
  };

  const [isMobile, setIsMobile] = React.useState(window.innerWidth < 768);

  React.useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const [notification, setNotification] = React.useState(false);
  const [notificationsData, setNotificationsData] = React.useState([]);
  const dropdownRef = React.useRef(null);
  const handleNotificationNavigate = (item) => {
    if (item.request_type.includes("crie")) {
      navigate(`/companyprofilescreen/${item?.joi_id}/1`);
    } else if (
      item.request_type.includes("enrichment") ||
      item.request_type.includes("Enrichment")
    ) {
      navigate("/dataenrich");
    } else {
    }
  };
  const getAuthData = GetOktaAuthData();
  const [open, setOpen] = React.useState(false);

  const [anchorEl, setAnchorEl] = React.useState(null);

  const openLogout = Boolean(anchorEl);
  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const loggingOut = async () => {
    await generateLastSessionReport();
    setTimeout(async () => {
      await oktaAuth.signOut({
        postLogoutRedirectUri: window.location.origin + "/",
        clearTokensBeforeRedirect: true,
      });
    }, 1000);

    localStorage.clear();
    sessionStorage.clear();
  };
  const [notificationPreferenceModal, setNotificationPreferenceModal] =
    React.useState(false);
  const userId = GetUserId();

  const getNotification = () => {
    // setLoading(true);
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "X-API-Key": APIUrlToken(),
      },
      url: `${APIUrlThree()}/v1/get_notifications?user_id=${userId}`,
    };
    axios(option)
      .then((response) => {
        if (response.data && response.data.data) {
          const sortedNotifications = response.data.data.sort(
            (a, b) => new Date(b.timestamp) - new Date(a.timestamp),
          );
          setNotificationsData(sortedNotifications);
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error(error.response?.data?.message);
      })
      .finally(() => {
        // setLoading(false);
      });
  };
  React.useEffect(() => {
    if (GetUserId()) {
      getNotification();
    }
  }, []);
  return (
    <>
      {isMobile ? (
        <>
          <div
            className={
              window.location.pathname === CONTACT_US
                ? "main-layout-mb-mob"
                : "main-layout-mb"
            }
          >
            {/* <div className="top-heading-joi">
              <p>
                JOI - Empowering Growth, Forging Connections and Driving Success
              </p>
            </div> */}
            <MHeader
              setNotification={setNotification}
              notification={notification}
              notificationsData={notificationsData}
              dropdownRef={dropdownRef}
              handleNotificationNavigate={handleNotificationNavigate}
              getAuthData={getAuthData}
              openLogout={openLogout}
              handleMenuClick={handleMenuClick}
              loggingOut={loggingOut}
              handleMenuClose={handleMenuClose}
              anchorEl={anchorEl}
              setNotificationPreferenceModal={setNotificationPreferenceModal}
              isMobile={isMobile}
            />
            {open ? (
              <Sidebar
                setRefState={setRefState}
                refState={refState}
                setRefStatenew={setRefStatenew}
                refStatenew={refStatenew}
              />
            ) : (
              ""
            )}
            {children}
            <MFooter setOpen={setOpen} />
          </div>
        </>
      ) : (
        <>
          {/* <div className="top-heading-joi">
            <p>
              JOI - Empowering Growth, Forging Connections and Driving Success
            </p>
          </div> */}
          <Box sx={{ display: "flex" }}>
            <Sidebar
              setRefState={setRefState}
              refState={refState}
              setRefStatenew={setRefStatenew}
              refStatenew={refStatenew}
            />
            <Box
              component="main"
              sx={{ flexGrow: 1, p: 3 }}
              className="padding-set"
            >
              <DrawerHeader />
              {children}
            </Box>
          </Box>
        </>
      )}

      <Modal
        open={timeWarning}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          {/* Header */}
          <div style={{ textAlign: "center", marginBottom: "16px" }}>
            <WarningAmberIcon sx={{ fontSize: 50, color: "#f57c00", mb: 1 }} />
            <h2 style={{ margin: 0, fontWeight: 600 }}>
              Session Expiring Soon
            </h2>
          </div>

          {/* Content */}
          <p
            style={{
              textAlign: "center",
              color: "#555",
              fontSize: "15px",
              marginBottom:
                window.location.pathname === "/atlas-chat" ? "0px" : "20px",
            }}
          >
            Your session will expire in 5 minutes due to inactivity.
          </p>
          {window.location.pathname === "/atlas-chat" ? (
            <p
              style={{
                textAlign: "center",
                color: "#555",
                fontSize: "15px",
                marginBottom: "20px",
              }}
            >
              Just send a message to keep the conversation going.
            </p>
          ) : (
            ""
          )}

          {/* Actions */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "10px",
              flexWrap: "wrap",
            }}
          >
            <Button className="de_next" onClick={() => setTimeWarning(false)}>
              {window.location.pathname === "/atlas-chat"
                ? "Continue Chatting"
                : "Close"}{" "}
            </Button>
          </div>
        </Box>
      </Modal>
    </>
  );
}
